import React, { useState } from "react";
import { Form } from "react-bootstrap";
import StyledInput from "../../components/StyledComponents/StyledInput";
import StyledText from "../../components/StyledComponents/StyledText";
import StyledButton from "../../components/StyledComponents/StyledButton";
import AuthSlider from "../../components/AuthSlider";
import { Link, useNavigate } from "react-router-dom";
import { emailValidationRules, validateForm } from "../../utils/helper";
import { toast } from "react-toastify";
import { useForgotPasswordMutation } from "../../services/apis";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();
  const [formData, setFormData] = useState({
    email: "",
  });
  const [errors, setErrors] = useState({});
  const handleInputChange = (fieldName, value) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: "",
    }));
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
  };
  const validationRules = {
    email: [...emailValidationRules],
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    const validationErrors = validateForm(formData, validationRules);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) return;

    try {
      const { error } = await forgotPassword({...formData, redirectUrl: `${window.location.origin}/forgot-password`}).unwrap();
      if (error) {
        toast.error(
          error?.errorMessage || error?.message || error?.data?.errorMessage ||
            "An unexpected error occurred. Please try again.",
        );
        console.error("Forgot Password error:", error);
        return;
      }
      if (!error) {
        navigate("/email-invitation", {
          state: {
            email: formData?.email,
            heading: "Password reset link sent",
            message:
              "If your email address is valid, you will receive an email to proceed with resetting your password. You entered the following address:",
            footnote:
              "Didn't receive the email? Check your spam folder.",
          },
        });
        setFormData({
          email: "",
        });
      }
    } catch (error) {
      toast.error("An unexpected error occurred. Please try again.");
      console.error("Error submitting form:", error);
    }
  };

  return (
    <AuthSlider>
      <h2 className="welcome-heading mb-2 text-center text-md-start">
        Forgot Your Password?
      </h2>
      <h5 className="signin-text text-center text-md-start">
        No worries! Enter your email address, and we'll send you a link to reset
        your password
      </h5>
      <Form noValidate onSubmit={handleSubmit} className="py-2 py-md-4 pb-md-0">
        <StyledInput
          label="Email Address"
          type="email"
          placeholder="Enter your email address here"
          value={formData.email}
          onChange={(e) => handleInputChange("email", e.target.value)}
          required
          error={errors.email}
        />

        <StyledButton
          _variant="primaryGradiant"
          loading={isLoading}
          type="submit"
          className="w-100 sign-in-btn p-md-3 mt-3 mt-md-5"
          $fontWeightMd="600"
        >
          Reset Password
        </StyledButton>
        <StyledText as="div" className="text-center mt-2" $fontSize="0.9rem">
          Don't have an account yet?
          <StyledText
            as={Link}
            color="secondary"
            to="/signup"
            className="fw-semibold ms-1"
          >
            Create Here
          </StyledText>
        </StyledText>
      </Form>
    </AuthSlider>
  );
};

export default ForgotPassword;
